import { TagList, TagModel } from "client/Components";
import { TagViewModel } from "client/Api/Tags/tags";
import { ReactElement, useMemo } from "react";
import { Section, SectionEmptyBehavior } from "./Section";

export type TagsSectionProps = {
	title: string;
	trackingId: string;
	tags: readonly TagViewModel[];
	emptyBehavior: SectionEmptyBehavior;
};

export const TagsSection = (props: TagsSectionProps): ReactElement => {
	const {
		title,
		trackingId,
		tags,
		emptyBehavior
	} = props;

	const tagModels: readonly TagModel<number>[] = useMemo(
		() => {
			return tags.map(
				(t): TagModel<number> => ({
					text: t.name,
					value: t.id,
					color: "secondary"
				})
			);
		},
		[tags]
	);

	return (
		<Section
			title={title}
			trackingId={trackingId}
			emptyBehavior={emptyBehavior}
			isEmpty={tags.length === 0}
		>
			<TagList
				tags={tagModels}
				responsiveBehavior="wrap"
				trackingId="tags"
			/>
		</Section>
	);
};
TagsSection.displayName = "TagsSection";